import type { NavigationItem } from '@/shared/types/navigation'

// Фирменные контурные иконки разделов (32×32, линия 2px) — те же, что на
// плитках «Главной». Рисуются через CSS-маску и красятся текущим цветом.
import IconHome from '@/assets/images/icons/sections/home.svg'
import IconConnect from '@/assets/images/icons/sections/connect.svg'
import IconSubscription from '@/assets/images/icons/sections/subscription.svg'
import IconDevices from '@/assets/images/icons/sections/devices.svg'
import IconFriends from '@/assets/images/icons/sections/friends.svg'
import IconFamily from '@/assets/images/icons/sections/family.svg'
import IconGuild from '@/assets/images/icons/sections/guild.svg'
import IconAchievements from '@/assets/images/icons/sections/achievements.svg'
import IconGifts from '@/assets/images/icons/sections/gifts.svg'
import IconPayments from '@/assets/images/icons/sections/payments.svg'
import IconProfile from '@/assets/images/icons/sections/profile.svg'

// Navigation items use i18n keys for labels
// Components should translate using $t() or t()
export const primaryNavigation: NavigationItem[] = [
  // IGRA-100 — «Подписка» это отдельный экран управления подпиской, а не
  // дашборд: два пункта с одним именем читались как одно место.
  { name: 'dashboard', label: 'nav.home', route: '/dashboard', icon: IconHome },
  // Решение оператора 2026-09-18 — «Ключ» сразу за «Главной», то есть
  // ПЕРВЫМ в верхней полоске телефона (пять разделов ниже живут в нижнем меню).
  // Оплативший человек не находил свой ключ: полоска начиналась с «Семьи» и
  // «Гильдии» — разделов про игру, а не про сам VPN.
  { name: 'connect', label: 'nav.connect', route: '/connect', icon: IconConnect },
  { name: 'routing', label: 'nav.routing', route: '/routing', icon: IconConnect },
  { name: 'subscription', label: 'nav.subscription', route: '/subscription', icon: IconSubscription },
  { name: 'devices', label: 'nav.devices', route: '/devices', icon: IconDevices },
  { name: 'friends', label: 'nav.friends', route: '/friends', icon: IconFriends },
  // IGRA-110 — «Поделиться подпиской» сразу за «Друзьями»: там зовут в круг за
  // скидку, здесь — в свою же подписку.
  { name: 'pool', label: 'nav.pool', route: '/share', icon: IconFamily },
  // IGRA-104 — сразу после «Друзей»: гильдия это та же ветка, только целиком.
  { name: 'guild', label: 'nav.guild', route: '/guild', icon: IconGuild },
  // IGRA-112 — «Награды» сразу после гильдии: и то, и другое про итог игры.
  { name: 'achievements', label: 'nav.achievements', route: '/achievements', icon: IconAchievements },
  { name: 'gifts', label: 'nav.gifts', route: '/gifts', icon: IconGifts },
  { name: 'payments', label: 'nav.payments', route: '/payments', icon: IconPayments },
  { name: 'profile', label: 'nav.profile', route: '/profile', icon: IconProfile },
]

/**
 * Пять разделов, которые на телефоне живут в нижнем меню с иконками. Остальные
 * остаются в верхней полоске, а что в неё не влезло — уходит в гамбургер.
 */
export const BOTTOM_NAVIGATION_NAMES = ['dashboard', 'subscription', 'devices', 'friends', 'payments']

export const secondaryNavigation: Record<string, NavigationItem[]> = {}
